import { env } from '@/src/shared/config'

export const WEBSOCKET_URL = env.SOCKET_URL
export const WEBSOCKET_APPLICATION = env.WEBSOCKET_APPLICATION
export const WEBSOCKET_EVENT = 'websocket'
export const WEBSOCKET_PLATFORM = 'web'
